import { sharedDeliveryTermHeading } from './sharedDeliveryTerm';

export const fixtureDeliveryTermHeading = {
    ...sharedDeliveryTermHeading,
    hide: false,
};
